import { OpenChatRoomCommandShortcutHandler } from '@/components/chat/_domain/modules/command-shortcut-service/handlers/open-chat-room';
import { UserBanCommandShortcutHandler } from '@/components/chat/_domain/modules/command-shortcut-service/handlers/user-ban';
import { UserSinBinCommandShortcutHandler } from '@/components/chat/_domain/modules/command-shortcut-service/handlers/user-sinbin';
import { UserSearchCommandShortcutHandler } from '@/components/chat/_domain/modules/command-shortcut-service/handlers/user-search';
import { OpenSettingsCommandShortcutHandler } from '@/components/chat/_domain/modules/command-shortcut-service/handlers/open-settings';
import { ToggleUserListSortOrderCommandShortcutHandler } from '@/components/chat/_domain/modules/command-shortcut-service/handlers/toggle-user-list-sort-order';
import { UserAwardChatPrizeCommandShortcutHandler } from '@/components/chat/_domain/modules/command-shortcut-service/handlers/user-award-chat-prize';
import { UserAwardOfflineChatPrizeCommandShortcutHandler } from '@/components/chat/_domain/modules/command-shortcut-service/handlers/user-award-offline-chat-prize';
import { ICommandShortcutHandler } from '@/components/chat/_domain/modules/command-shortcut-service/command-shortcut-service-interface';

const commandShortcutHandlerTypes: { [key: string]: new() => ICommandShortcutHandler} = {
  OpenChatRoomCommandShortcutHandler,
  UserBanCommandShortcutHandler,
  UserSinBinCommandShortcutHandler,
  UserSearchCommandShortcutHandler,
  OpenSettingsCommandShortcutHandler,
  ToggleUserListSortOrderCommandShortcutHandler,
  UserAwardChatPrizeCommandShortcutHandler,
  UserAwardOfflineChatPrizeCommandShortcutHandler
};

export { commandShortcutHandlerTypes };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/modules/command-shortcut-service/handlers/index.ts